import { OPEN, CLOSE } from './resetPasswordType';

export const initialState = {
  isOpen: false,
};

const resetPasswordReducer = (state = initialState, action) => {
  switch (action.type) {
    case OPEN:
      const openState = {
        ...state,
        isOpen: true,
      };
      return openState;

    case CLOSE:
      const closeState = {
        ...state,
        isOpen: false,
      };
      return closeState;

    default:
      return state;
  }
};

export default resetPasswordReducer;
